module.exports = __webpack_public_path__ + "static/img/1650521253(1).2a383ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1650521253(1).png
// module id = 9Ahy
// module chunks = 167